import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	favorites: {
		id: 'spa-apps-sidebar-core.multi-project-menu.project-group.favorites',
		defaultMessage: 'Starred',
		description: 'Label of the section grouping favorited projects.',
	},
	recents: {
		id: 'spa-apps-sidebar-core.multi-project-menu.project-group.recents',
		defaultMessage: 'Recent',
		description: 'Label of the section grouping recent projects.',
	},
	expandSection: {
		id: 'spa-apps-sidebar-core.multi-project-menu.project-group.expand-section',
		defaultMessage: 'Expand {section} projects',
		description: 'Aria label describing the expand project menu button.',
	},
	collapseSection: {
		id: 'spa-apps-sidebar-core.multi-project-menu.project-group.collapse-section',
		defaultMessage: 'Collapse {section} projects',
		description: 'Aria label describing the collapse project menu button.',
	},
});
